import { Injectable } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { ObjectTypesService } from './object-types.service';
import { getObjectTypeNameTextId } from '@fi-shared/utils';

@Injectable()
export class ObjectTitleService {
    constructor(
        private appTextService: AppTextService,
        private objectTypesService: ObjectTypesService,
    ) {}

    getTitleForBrowserTab(id: number, name: string, objectType) {
        if (id) {
            return (
                this.appTextService.get('common.edit') +
                ' ' +
                this.appTextService.get(getObjectTypeNameTextId(objectType)).toLowerCase()
            );
        }
        return this.getCreateTitle(objectType);
    }

    GetTitle(id: number, name: string, objectType?) {
        return id ? this.getEditTitle(name) : this.getCreateTitle(objectType);
    }

    getEditTitle(value) {
        return this.appTextService.get('common.edit') + ' ' + value;
    }

    getCreateTitle(objectType) {
        const textId = this.objectTypesService.getTextIdForTitleCreate(objectType);
        if (textId) {
            return this.appTextService.get(textId);
        } else {
            return 'New Item';
        }
    }
}
